export const ROLE_SUPER_ADMIN = 'SUPER_ADMIN';
export const ROLE_ORG_ADMIN = 'ORG_ADMIN';
export const ROLE_ORG_MEMBER = 'ORG_MEMBER';
const LEGACY_ADMIN = 'ADMIN';
const LEGACY_USER = 'USER';

export type NormalizedRole =
  | typeof ROLE_SUPER_ADMIN
  | typeof ROLE_ORG_ADMIN
  | typeof ROLE_ORG_MEMBER;

export const normalizeRole = (role?: string): NormalizedRole => {
  const normalized = (role || '').toUpperCase();

  if (normalized === LEGACY_ADMIN) return ROLE_SUPER_ADMIN;
  if (normalized === LEGACY_USER || !normalized) return ROLE_ORG_MEMBER;

  if ([ROLE_SUPER_ADMIN, ROLE_ORG_ADMIN, ROLE_ORG_MEMBER].includes(normalized as NormalizedRole)) {
    return normalized as NormalizedRole;
  }

  return ROLE_ORG_MEMBER;
};

export const isSuperAdmin = (role?: string) => normalizeRole(role) === ROLE_SUPER_ADMIN;
export const isOrgAdmin = (role?: string) => {
  const normalized = normalizeRole(role);
  return normalized === ROLE_ORG_ADMIN || normalized === ROLE_SUPER_ADMIN;
};
